import { localStorageKey } from '@/constants/localstorage-key'
import { LOGIN_PAGE_URL } from '@/constants/url'

export const moveToLoginPage = () => {
  const pathname = location.pathname

  localStorage.setItem(localStorageKey.loginRedirectUrl, pathname)

  location.href = LOGIN_PAGE_URL
}
